/**
 * Open campaign pushes to the Twiva mobile app.
 *
 * When an agency creates a campaign that isn't invite only, or turns "Invite only" off, everyone
 * on the Twiva app gets a push about it (product decision, 4 Nov 2026). The push is sent by the
 * `announceOpenCampaign` Cloud Function in the Flutter app's repo (twiva/functions/src/
 * open_campaigns.js). We pass the signed-in staff member's agency API login; the function uses
 * it once to read the campaign through the agency API, so it only ever pushes a real, open
 * campaign of this agency, and each campaign only once. Quiet hours and a daily cap are its job.
 *
 * Best effort: a failure here never fails the save, it only means no push.
 */
import { getToken } from './api';

const URL =
  import.meta.env.VITE_OPEN_CAMPAIGN_PUSH_URL ||
  'https://europe-west1-twiva-d8885.cloudfunctions.net/announceOpenCampaign';

export function announceOpenCampaign(campaignId: string): void {
  const token = getToken();
  if (!token || !campaignId || import.meta.env.VITE_OPEN_CAMPAIGN_PUSH_URL === 'off') return;
  void fetch(URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ campaignId }),
  })
    .then(async (response) => {
      const reply = (await response.json().catch(() => ({}))) as { status?: string };
      // sent, queued (quiet hours / daily cap), already_announced, invite_only, not_open…
      console.info('[open campaign push]', campaignId, reply.status ?? response.status);
    })
    .catch((error) => console.warn('[open campaign push] failed', error));
}
